import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DataManager } from 'techlify-ng';
import { AlertService } from 'techlify-ng';
import { RequestErrorService } from 'techlify-ng';

import { SchoolInformation } from './school-information.model';

/**
 * Controller used to edit a School Information
 * 
 * @author Floyd Kissoon
 * @since 20190729
 */
@Component({
    selector: 'school-information-edit',
    templateUrl: './school-information-form.html'
})
export class SchoolInformationEditComponent {

    @Input() schoolInfo: SchoolInformation;
    @Output() onSave = new EventEmitter<SchoolInformation>();
    private isWorking = false;
    constructor(private dataManager: DataManager, private alertService: AlertService,
        private errorHandler: RequestErrorService) { }

    save() {
        this.isWorking = true;
        this.dataManager.PUT('api/school-information/' + this.schoolInfo.id, this.schoolInfo).then(
            res => {
                this.onSave.emit(res.item);
                this.alertService.addAlert('Successfully updated school information', 'success');
                this.isWorking = false;
            },
            error => {
                this.errorHandler.handleError(error);
                this.isWorking = false;
            }
        );
    }
}